/** 与后端 TransportContractDict 及库表数字约定一致 */

export const FEE = {
  WAREHOUSE: 1,
  LOAD: 2,
  RAIL_UNLOAD: 3,
  TRUCK_PIT: 4,
  WATER: 5,
  ELECTRIC: 6,
  HEATING: 7,
  SEWAGE: 8,
  PROPERTY: 9,
};

export const UNIT = {
  TON: 1,
  TRUCK_COUNT: 2,
  CUBE: 3,
  /** 仓储服务费：堆位占地㎡ = layoutW×layoutH（米） */
  SQUARE_METER: 4,
};

export const SETTLE = {
  MONTH: 1,
  QUARTER: 2,
  YEAR: 3,
  PREPAY: 4,
};

export const COPY = {
  TWO_PARTIES: 1,
  THREE_WITH_FILING: 2,
  FOUR: 3,
};

export const FEE_OPTIONS = [
  { label: "仓储服务费", value: FEE.WAREHOUSE },
  { label: "装车服务费", value: FEE.LOAD },
  { label: "翻车机卸煤费", value: FEE.RAIL_UNLOAD },
  { label: "汽车受煤坑卸煤费", value: FEE.TRUCK_PIT },
  { label: "水费", value: FEE.WATER },
  { label: "电费", value: FEE.ELECTRIC },
  { label: "暖气费", value: FEE.HEATING },
  { label: "污水处理费", value: FEE.SEWAGE },
  { label: "物业费", value: FEE.PROPERTY },
];

export const UNIT_OPTIONS = [
  { label: "吨", value: UNIT.TON },
  { label: "车数", value: UNIT.TRUCK_COUNT },
  { label: "立方", value: UNIT.CUBE },
  { label: "平方米", value: UNIT.SQUARE_METER },
];

export const SETTLE_OPTIONS = [
  { label: "月结", value: SETTLE.MONTH },
  { label: "季结", value: SETTLE.QUARTER },
  { label: "年结", value: SETTLE.YEAR },
  { label: "预付款", value: SETTLE.PREPAY },
];

export const COPY_OPTIONS = [
  { label: "一式两份，双方各执一份", value: COPY.TWO_PARTIES },
  { label: "一式三份，双方各执一份，备案一份", value: COPY.THREE_WITH_FILING },
  { label: "一式四份", value: COPY.FOUR },
];

const FEE_LABEL = FEE_OPTIONS.reduce((m, o) => {
  m[o.value] = o.label;
  return m;
}, {});
const UNIT_LABEL = UNIT_OPTIONS.reduce((m, o) => {
  m[o.value] = o.label;
  return m;
}, {});
const SETTLE_LABEL = SETTLE_OPTIONS.reduce((m, o) => {
  m[o.value] = o.label;
  return m;
}, {});

export function feeLabel(v) {
  return FEE_LABEL[v] != null ? FEE_LABEL[v] : v != null && v !== "" ? String(v) : "—";
}
export function unitLabel(v) {
  return UNIT_LABEL[v] != null ? UNIT_LABEL[v] : v != null && v !== "" ? String(v) : "—";
}
export function settleLabel(v) {
  return SETTLE_LABEL[v] != null ? SETTLE_LABEL[v] : v != null && v !== "" ? String(v) : "—";
}

export function copyCountLabel(v) {
  const o = COPY_OPTIONS.find((x) => x.value === v);
  return o ? o.label : v != null && v !== "" ? String(v) : "—";
}

export const UTIL_FEE_VALUES = [FEE.WATER, FEE.ELECTRIC, FEE.HEATING, FEE.SEWAGE, FEE.PROPERTY];
